import request from '@/utils/requestAd'

export function companySeat(params) { // 座位表
  return request({
    url: '/companySeat/get/list',
    method: 'get',
    params
  })
}

